import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=0320d8ed&scoped=true"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"
import style0 from "./Status.vue?vue&type=style&index=0&id=0320d8ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0320d8ed",
  null
  
)

export default component.exports